import axios from "axios";
import React, { Component } from "react";
import Header from "./Header.js";
import Server from "./Server.js";
import LoginBox from "./LoginBox.js";
import {  Navigate, Link } from "react-router-dom";
import { ProgressSpinner } from 'primereact/progressspinner';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.getAppData = this.getAppData.bind(this);
    this.Server = new Server();
    this.state = {
      ShowLoading: true,
      System: this.Server.getSystem(),
      place: this.Server.getPlace()
    };
  }

  async componentDidMount() {
    await this.getAppData();
    if (!document.referrer.includes("android-app://")) {
      this.setState({
        showWebElements: true,
      });
    }
  }

  async getAppData() {
    let that = this;
    let SCallBack = function (response) {
      const appData = response.data.result[0] || {};
      that.setState({
        appData: appData,
        ads: response.data.ads ? response.data.ads[0] : {},
        ShowLoading: false,
      });
    };
    let ECallBack = function (error) {};
    const condition = this.state.System
      ? { condition: { code: this.state.System.code } }
      : { condition: { code: 1000 } };
    this.Server.send("MainApi/getAppData", condition, SCallBack, ECallBack);
  }

  gotStories() {
    let that = this;
    var headers = {
      "Content-Type": "application/json; charset=utf-8",
      dataType: "json",
      "Access-Control-Allow-Origin": "*",
    };
    axios
      .get("https://graph.facebook.com/ansar724_com/stories", {
        headers: headers,
      })
      .then((response) => {})
      .catch((error) => {});
  }
  render() {
    if (this.state.GotoHome) {
      return <Navigate to={"/Home"} />;
    }
    return (
      <div
        className="sarv-bg1 sarv-home-top-box"
        style={{
          textAlign: "right",
          height: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {!this.state.ShowLoading ? (
          <div>
            {this.state.appData && (
              <Header appDataParam={this.state.appData} noBack={true} />
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                flexWrap: "wrap",
                height: "calc(100% - 100px)",
                marginTop: 20,
              }}
            >
              <div style={{ width: "900%" }}>
                {this.state.appData.lName &&
                  <LoginBox appData={this.state.appData} inForceLogin={true} AfterLogin={()=>{
                    debugger;
                    this.setState({
                      GotoHome: true
                    })
                  }} />
                }
                
                {this.state.appData && this.state.appData.hasAndroid && (
                  <p style={{ textAlign: "center", marginTop: 80 }}>
                    <a
                      className="iranyekanwebmedium  sarv-btn-color"
                      target="_blank"
                      href={`${this.state.absoluteUrl}app.apk`}
                      style={{
                        textAlign: "center",
                        borderRadius: 8,
                        padding: "8px 8px",
                        fontSize: 16,
                        fontWeight: "bold",
                      }}
                    >
                      {" "}
                      <span
                        className="iranyekanwebmedium"
                        style={{ width: "100%", fontSize: 18 }}
                      >
                        دانلود اپلیکیشن
                      </span>{" "}
                    </a>
                  </p>
                )}
                {this.state.showAd && (
                  <div
                    className="login-ad"
                    style={{ backgroundImage: `url("./add-test.jpg")` }}
                  >
                    <a
                      href="#"
                      style={{ position: "absolute", top: 5, right: 5 }}
                      onClick={() => {
                        this.setState({
                          showAd: false,
                        });
                      }}
                    >
                      <i
                        className="fal fa-times-circle"
                        style={{ fontSize: 25, color: "red", fontWeight: 500 }}
                      ></i>
                    </a>
                    <img
                      src="./ad.png"
                      style={{
                        width: 30,
                        position: "absolute",
                        left: 0,
                        top: 0,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        )}
      </div>
    );
  }
}
export default Login;
